var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('title-bar',{attrs:{"show-back":true}}),_c('div',{staticClass:"grid-container"},[_c('NotificationTable',{staticClass:"table",attrs:{"notifications":_vm.notifications}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }